import React, {CSSProperties} from "react";
import {getLovItem, lovLabel, lovParam, lovValue} from 'core/form/formUtils';
import {green500, grey200, grey700, red400, white} from "material-ui/styles/colors";
import "core/security/component/securableBlocks.less";
import {action, ObservableMap} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {ISECURABLE, MODULE, PERMISSION, SECURABLE} from "core/metamodel/metaConstant";
import {SecurableDefinition, SecurableDefinitionModuleMap, SecurableDefinitionSecurableMap, SecurablePermission, SecurablePermissionDetail, TPermissionMap} from "core/security/securityDomain";
import {observer} from "mobx-react";
import {createIfAbsent} from "core/common/utils/jsonUtils";
import SvgDone = require('react-icons/lib/md/done');
import SvgClear = require('react-icons/lib/md/clear');


interface SecurablesResolvedProps {
  entities: ObservableMap<MdEntity>;
  permissionMap: TPermissionMap;
  securables: SecurableDefinitionModuleMap;
}



const TH_STYLE: CSSProperties = {position: "sticky", top: 82, zIndex: 100, backgroundColor: white};
const TD_STYLE: CSSProperties = {paddingTop: 5, paddingBottom: 5};
const TD_STYLE_GREY: CSSProperties = {paddingTop: 5, paddingBottom: 5, backgroundColor: grey200};

@observer
export class SecurablesResolved extends React.Component<SecurablesResolvedProps, undefined> {

  render() {
    let {entities, permissionMap, securables} = this.props;

    let permissionKeys = Object.keys(PERMISSION);
    let permissionKeysDetailable = permissionKeys.filter(p => ![PERMISSION.PublicGrid, PERMISSION.TenantGrid, PERMISSION.TenantGroupGrid].includes(p as PERMISSION));

    let permissionModuleMap: Record<MODULE, SecurablePermission[]> = Object.values(permissionMap).reduce( (acc, sp) => {
      createIfAbsent(acc, sp.module, (k) => []).push(sp);
      return acc;
    }, {} as any);

    return (
      <table className="zz-simple-table" style={{position: "relative", margin: 20}}>
        <thead>
        <tr>
          <th style={TH_STYLE}/>
          {permissionKeys.map( (p,i) => (<th key={i} style={TH_STYLE}>{p}</th>))}
          <th style={TH_STYLE}/>

        </tr>
        </thead>
        {
          Object.entries(permissionModuleMap).map(([module, securablePermissions]) => {
            const moduleLov = getLovItem(entities.get('MODULE').lovItems, module);
            const securableDefMap: SecurableDefinitionSecurableMap = securables[module];

            return (
              <tbody key={module}>
              <tr>
                <td colSpan={permissionKeys.length + 1} style={{paddingTop: 10, paddingBottom: 10}}>
                  <div className="secu-module-header" style={{justifyContent: "center"}}>
                    <span className={lovParam(moduleLov, 'icon')}/>
                    <div className="text">{lovLabel(moduleLov)}</div>
                  </div>
                </td>
              </tr>
              {
                securablePermissions.map( (securablePermission, index) => {
                    const securableDef = securableDefMap[securablePermission.securable.value];
                    const securableConfig: ISECURABLE = SECURABLE[lovValue(securablePermission.securable)];
                  return (
                    (securableConfig && securableConfig.detailHeader) ? (
                      <tr key={index}>
                        <td style={{...TD_STYLE, paddingRight: 0, paddingBottom: 0}} colSpan={permissionKeys.length + 1 - 3}>
                          <table className="zz-small-table" style={{width: "100%"}}>
                            <thead>
                              <tr>
                                <th title={securablePermission.getTuple("contributingRole")}><span style={{fontSize: 14, marginLeft: -10, fontWeight: "normal", color: grey700}}>{lovLabel(securablePermission.securable)}</span></th>
                                {
                                  permissionKeysDetailable.map( (permKey, index) => <th key={index} style={{fontSize: 12}}>{permKey}</th>)
                                }
                              </tr>
                            </thead>
                          {
                            securablePermission.detailPermissions.values().map((spd, index) => (
                              <tr key={index}>
                                <td style={{fontSize: 12}}>{(spd.label) ? spd.label : spd.detailId}</td>
                                <SecCellDet securableDef={securableDef} permission={PERMISSION.Read} spd={spd}/>
                                <SecCellDet securableDef={securableDef} permission={PERMISSION.New} spd={spd}/>
                                <SecCellDet securableDef={securableDef} permission={PERMISSION.Update} spd={spd}/>
                                <SecCellDet securableDef={securableDef} permission={PERMISSION.Delete} spd={spd}/>

                                <SecCellDet securableDef={securableDef} permission={PERMISSION.Execute} spd={spd}/>
                                <SecCellDet securableDef={securableDef} permission={PERMISSION.Export} spd={spd}/>
                                <SecCellDet securableDef={securableDef} permission={PERMISSION.Import} spd={spd}/>
                              </tr>
                            ))
                          }
                          </table>
                        </td>
                        <SecCell securableDef={securableDef} permission={PERMISSION.PublicGrid} securablePermission={securablePermission} style={{verticalAlign: 'top'}}/>
                        <SecCell securableDef={securableDef} permission={PERMISSION.TenantGrid} securablePermission={securablePermission} style={{verticalAlign: 'top'}}/>
                        <SecCell securableDef={securableDef} permission={PERMISSION.TenantGroupGrid} securablePermission={securablePermission} style={{verticalAlign: 'top'}}/>
                      </tr>
                      ) : (
                      <tr key={index}>
                        <td style={TD_STYLE} title={securablePermission.getTuple("contributingRole")}>{lovLabel(securablePermission.securable)}</td>
                        <SecCell securableDef={securableDef} permission={PERMISSION.Read} securablePermission={securablePermission}/>
                        <SecCell securableDef={securableDef} permission={PERMISSION.New} securablePermission={securablePermission}/>
                        <SecCell securableDef={securableDef} permission={PERMISSION.Update} securablePermission={securablePermission}/>
                        <SecCell securableDef={securableDef} permission={PERMISSION.Delete} securablePermission={securablePermission}/>

                        <SecCell securableDef={securableDef} permission={PERMISSION.Execute} securablePermission={securablePermission}/>
                        <SecCell securableDef={securableDef} permission={PERMISSION.Export} securablePermission={securablePermission}/>
                        <SecCell securableDef={securableDef} permission={PERMISSION.Import} securablePermission={securablePermission}/>

                        <SecCell securableDef={securableDef} permission={PERMISSION.PublicGrid} securablePermission={securablePermission}/>
                        <SecCell securableDef={securableDef} permission={PERMISSION.TenantGrid} securablePermission={securablePermission}/>
                        <SecCell securableDef={securableDef} permission={PERMISSION.TenantGroupGrid} securablePermission={securablePermission}/>
                      </tr>
                    )
                  );
                }

                )
              }
              </tbody>
            )})
        }
      </table>

    )
  }


}

const GREEN_STYLE = {color: green500};
const RED_STYLE = {color: red400};

function SecCell({securableDef, permission, securablePermission, style}: {securableDef: SecurableDefinition, permission: PERMISSION, securablePermission: SecurablePermission, style?: CSSProperties})  {
  let tdStyle = (securableDef.availablePermissions.includes(permission)) ? TD_STYLE : TD_STYLE_GREY;
  if (style) tdStyle = {...tdStyle, ...style};
  return (
    <td style={tdStyle}>
      { (securablePermission.isPermission(permission)) ? <SvgDone style={GREEN_STYLE} size={16}/> :
        ( (securableDef.availablePermissions.includes(permission)) ? <SvgClear style={RED_STYLE} size={16}/> : <div/> )
      }
    </td>
  )
}

function SecCellDet({securableDef, permission, spd}: {securableDef: SecurableDefinition, permission: PERMISSION, spd: SecurablePermissionDetail})  {
  const tdStyle = (securableDef.availablePermissions.includes(permission)) ? {} : {backgroundColor: grey200};
  return (
    <td style={tdStyle}>
      { (spd.isPermission(permission)) ? <SvgDone style={GREEN_STYLE} size={12}/> :
        ( (securableDef.availablePermissions.includes(permission)) ? <SvgClear style={RED_STYLE} size={12}/> : <div/> )
      }
    </td>
  )
}




// WEBPACK FOOTER //
// ./src/core/security/component/securableResolved.tsx